import { type ReactNode } from 'react'
import { create } from 'zustand'

export type CustomDomainDescriptionState = {
  description: {
    icon: ReactNode | null
    text: ReactNode
    color: string
  } | null
  setDescription: (
    description: CustomDomainDescriptionState['description']
  ) => void
}

export const useCustomDomainDescription = create<CustomDomainDescriptionState>(
  (set) => ({
    description: null,
    setDescription: (description) => set({ description }),
  })
)
